/**
* @param {string} val
* @return {string}
*/

window.toThousandSeparator =  function(num)
{
    let res = "";

    if(Number.parseInt(num))
    {
        let val = parseFloat(num).toFixed(2);
        val = val.toString();


        let split = val.split(".");


        const str = split[0];

        const arr = str.split('');
        const firstDigit = arr[0];
            arr.shift();
        const reverse = arr.reverse();

        if(reverse.length >= 3 && split[1])
        {

            for (let i = 0; i < reverse.length; i += 3)
            {
                res +=  (reverse[i] || '');
                res += ( reverse[i+1] || '' );
                res += ( reverse[i+2] || '' );
                res += reverse[i+2] ?"'": "";
            }

            res = firstDigit + (res.split("").reverse().join(""));

            res += "."+split[1];
        }
        else
        {
            res = num;
        }
    }
    else if(num === 0)
    {
        res = "0.00";
    }


    return res;
}


window.removeThousandSeparator =  function(num)
{
    if(num)
    {
        if(typeof num !== 'string')
        {
            num = num.toString()
        }
        if(num.includes("'")){

           num = parseFloat(num.replace(/'/g, '')).toFixed(2);

        }

    }

    return num;
}
//student tabs common function
window.showApplicationTab = function(roles = []) {
    if (roles) {
        let found = roles.find(role => {
            if (
                role.slug == 'admin' ||
                role.slug == 'management' ||
                role.slug == 'program.bba' ||
                role.slug == 'program.msc' ||
                role.slug == 'program.mba' ||
                role.slug == 'registrar' ||
                role.slug == 'partner.school' ||
                role.slug == 'program.all')
                return true
            else
                return false;
        });

        if (found) return true;
    }

    return false;
}



window.clearLockedCache = async function(id = 0, form = '') {
    if (id && form) {

        await axios
            .get("/api/clear-lock-cache/" + id + "/" + form);

    } else
        return;

}

/**
 *
 * @param {*} offset
 * getting calculated time by passing offset
 * @returns
 */

window.calculateTimeAsPerTimeZone = function(offset){

    // create Date object for current location
    var d = new Date();

    // convert to msec
    // subtract local time zone offset
    // get UTC time in msec
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);

    // using supplied offset
    var nd = new Date(utc + (3600000*offset));
    //converting in proper format
    var date = moment(nd).format('DD.MM.YYYY HH:mm:ss')
    return date;

}
